import React from "react";
import WorshipArticleLayout from "./WorshipArticleLayout";
import {SeoHelper} from "../../components/helpers/SeoHelper";

const PlanWorshipForSunday = () => {
    return (
        <WorshipArticleLayout
            title="Plan Worship for your next Service"
            subtitle="Guidance to help you prepare worship that is rooted in Scripture, shaped with care, and ready for your next service."
            secondaryCta={{
                title: "Looking for a Scripture-first approach?",
                text: "Many worship leaders find that beginning with Scripture helps bring clarity and focus when planning a service.",
                label: "Worship Songs by Bible Passage",
                href: "/worship/worship-songs-by-bible-passage"
            }}
            primaryCta={{
                title: "Begin Planning",
                label: "Start with a Bible Passage",
                href: "/scripture/choose-song-book"
            }}
        >
            <SeoHelper
                uri = "/worship/plan-worship-for-your-next-service"
                title = "Plan Worship for your next Service"
                description="Guidance to help you prepare worship that is rooted in Scripture, shaped with care, and ready for your next service."
            />


            <p className="article-intro">
                Sunday comes whether we feel ready or not. Planning worship can feel weighty — especially when time is short and expectations are high.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Start with What God Is Saying</h2>
            <p>
                Many worship services feel fragmented because planning begins with songs or themes rather than Scripture. Beginning with a Bible passage helps worship grow from God’s word, rather than being assembled around it.
            </p>

            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pb-3">Let Worship Take Shape Naturally</h2>
            <p>
                Once Scripture is central, themes often emerge naturally — praise, confession, assurance, thanksgiving, or dedication. Songs can then be chosen as responses to what has already been read and proclaimed.
            </p>

            <ul style={{marginTop: 0 + "cm", fontWeight: 300}} type="square" className="MsoNormal"><li>Begin with a passage or reading</li><li>Notice the themes that emerge</li><li>Select songs that respond faithfully</li><li>Order worship to tell a clear story</li></ul>

            <h3 style={{fontSize: '1rem'}} className="MsoNormal text-primary">Planning with Confidence</h3>
            <p>
                You don’t need a perfect service plan. Faithful worship grows from attentiveness to Scripture and sensitivity to the congregation God has entrusted to you.
            </p>

            <p>
                The Worship Bible helps you begin with Scripture and discover songs that reflect its themes — supporting worship that is thoughtful, coherent, and grounded in God’s word.
            </p>

        </WorshipArticleLayout>
    );
};

export default PlanWorshipForSunday;